import { createAsyncThunk } from '@reduxjs/toolkit';
import portalApi from '../../core/api/portal.api';
import { GraphQlError } from '../../core/types/common.types';
import { SiteSearchRequest, SiteSearchResponse, SiteSearchResponseFull } from './types';

export const siteSearchThunk = createAsyncThunk<
  // Return type of the payload creator
  SiteSearchResponse,
  // First argument to the payload creator
  SiteSearchRequest,
  // Types for ThunkAPI
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('siteSearch', async (values, thunkApi) => {
  const response: SiteSearchResponseFull = await portalApi.searchSites(values);
  const errors = response.errors;
  const sitesResponse = response.data?.searchSites;

  if (errors) {
    return thunkApi.rejectWithValue(errors);
  }
  return sitesResponse as SiteSearchResponse;
});
